import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-card",
  "use": "add-card-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 31\" id=\"add-card\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M0 16c0 8.288 6.713 15 15 15 8.288 0 15-6.712 15-15 0-8.287-6.712-15-15-15C6.713 1 0 7.713 0 16z\" fill=\"#D0D2D4\" /><path d=\"M0 15c0 8.288 6.713 15 15 15 8.288 0 15-6.712 15-15 0-8.287-6.712-15-15-15C6.713 0 0 6.713 0 15z\" fill=\"#FFF\" /><path fill=\"#516EB7\" d=\"M16 16v4h-2v-4h-4v-2h4v-4h2v4h4v2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol